<script>
  import { navigate } from 'svelte-navigator';
  import { db } from '../firebase';

  import ClassColor from '../components/ClassColor.svelte';

  let thisClass;
  let isCounting,
    notFound = false;
  let count = '';

  export let classid;
  let currentColor;
  let previousColor;
  let firstLoad = true;

  db.collection('classes')
    .doc(classid)
    .onSnapshot((snap) => {
      if (snap.exists) {
        thisClass = snap.data();
        if (thisClass.previous) {
          previousColor = thisClass.previous;
        } else {
          previousColor = thisClass.currentColor;
        }
        currentColor = thisClass.currentColor;
        colorCycle();

        if (firstLoad) {
          previousColor = '';
          firstLoad = false;
        }
      } else {
        notFound = true;
      }
    });

  const colorCycle = () => {
    isCounting = true;
    count = '3';
    setTimeout(() => {
      count = '2';
    }, 1000);
    setTimeout(() => {
      count = '1';
    }, 2000);
    setTimeout(() => {
      previousColor = currentColor;
      isCounting = false;
    }, 3000);
  };
</script>

<div class="columns">
  <div class="column is-half-desktop is-offset-one-quarter has-text-centered">
    <h3 class="title is-4">
      <code on:click={() => navigate('/')}>{classid}</code> class
    </h3>
    {#if currentColor}
      <ClassColor color={previousColor} />
      <ClassColor color={currentColor} {isCounting} {count} />
    {:else if notFound}
      <p>That class was not found. Please try again.</p>
      <br />
      <button class="button is-primary" on:click={() => navigate('/')}>
        Go back
      </button>
    {:else}
      <progress class="progress is-primary my-6" max="100">15%</progress>
    {/if}
  </div>
</div>
